module.exports = __webpack_public_path__ + "img/Mamun-Logo.e01e1b77.png";